module.exports = __webpack_public_path__ + "static/media/ES.50184351.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ES.svg
// module id = 247
// module chunks = 0